<pdq-card variant="popover" color="white">
  <div class="card">
    <div class="card__header">
      <pdq-heading element="h5">Token</pdq-heading>
    </div>
    <pdq-divider></pdq-divider>
    <div class="card__content">
      <pdq-input [formControl]="tokenControl" [readonly]="true" [clipboard]="true"></pdq-input>
    </div>
  </div>
</pdq-card>
